import { useSelector } from "react-redux"

import { usePlansQuery } from "data/queries/users/plans"

const Prefetch = () => {
  const userId = useSelector(state => state.user.id)

  usePlansQuery(userId)

  return null
}

export default Prefetch
